import SelectableSearchableSortableListCtrl from '../../SelectableSearchableSortableListCtrl';

import editSalariesUrl from './editSalariesComponent.html';

class EditSalariesCtrl extends SelectableSearchableSortableListCtrl {
  constructor(
    Authentication,
    PersonaCollection,
    UserUtils,
    Utils,
    possessiveFilter,
    filterFilter,
    displayNumberFilter,
    $parse
  ) {
    'ngInject';

    super(filterFilter, $parse);

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      UserUtils,
      Utils,
      possessiveFilter,
      filterFilter,
      displayNumberFilter,
      $parse,
    });
  }

  $onInit() {
    this.numberWithDecimalPattern = this.Utils.getNumberValidationPattern();
    this.sortMethod = 'location';
    this.filterCurrent = (array) => {
      const historicalWagesIds = this.user.historicalWages.map((w) => w.wage.id);
      return array.filter((w) => w.isSalary && !historicalWagesIds.includes(w.id));
    };
    this.mapCopy = (array) => array.map((w) => ({ ...w }));

    /**
     * Binding out to the caller
     */
    this.outRefresh = () => this.refresh();
    this.outGetSalariesToBulkUpdate = () => this.getSalariesToBulkUpdate();

    this.emptyGroupsText = this.user.isMe
      ? 'Add yourself to a position and location first, to be able to define your wages.'
      : 'Add this employee to a position and location first, to be able to define their wages.';

    this.refresh();

    this.locations = this.user.locations.map((location) => ({
      ...location,
      _whoseLocations: `${this.possessiveFilter(this.user.name)} locations`,
    }));

    this.positions = this.user.positions.map((position) => ({
      ...position,
      _whosePositions: `${this.possessiveFilter(this.user.name)} positions`,
    }));
  }

  get user() {
    return this.PersonaCollection.personasDict[this.userId];
  }

  get hasAccessToLaborCost() {
    return this.Authentication.user.hasAccessToLaborCost;
  }

  refresh() {
    this.currentSalaries = this.filterCurrent(this.mapCopy(this.user.salaryWages));
  }

  addSalaryRate() {
    const newSalary = {
      _editing: true,
      fromDate: this.UserUtils.getSalaryDefaultDate(this.user),
    };

    if (this.user.locations.length === 1) {
      newSalary.location = this.user.locations[0];
    }

    if (this.user.positions.length === 1) {
      newSalary.position = this.user.positions[0];
    }

    this.currentSalaries.push(newSalary);
    this.form?.$setDirty();
  }

  deleteSalaryRate(salary) {
    salary.deleted = true;
    this.form?.$setDirty();
  }

  editSalaryRate(salary) {
    salary._editing = true;
    this.form?.$setDirty();
  }

  sortBy(sortMethod) {
    const currentMethod = this.sortMethod;
    if (currentMethod === sortMethod) {
      this.sortMethod = `-${sortMethod}`;
    } else {
      this.sortMethod = sortMethod;
    }
  }

  getSalariesToBulkUpdate() {
    return this.currentSalaries
      .filter((s) => (s.deleted && s.id) || !s.id || s._editing)
      .map((s) => ({
        ...s,
        isSalary: true,
        userId: this.user.id,
        locationId: s.location?.id ?? s.locationId,
        positionId: s.position?.id ?? s.positionId,
      }));
  }
}

export default {
  bindings: {
    outRefresh: '=?refresh',
    outGetSalariesToBulkUpdate: '=?getSalariesToBulkUpdate',
    userId: '<',
    readOnly: '<?',
  },
  require: {
    form: '?^form',
  },
  controller: EditSalariesCtrl,
  controllerAs: 'ctrl',
  templateUrl: editSalariesUrl,
};
